export const feedbackKeys = {
  list: ['feature-feedback', 'ExercisesCatalog'] as const,
} as const;
